import { createFileRoute } from '@tanstack/react-router'

import { DirectoryPage } from '@/features/directory/components/directory-page'

export const Route = createFileRoute('/_authed/directory')({
  component: DirectoryPage,
})
